import { createToastGlobal } from './components/Toast';
import { createErrorBannerGlobal } from './components/ErrorBanner';
import { createConfirmDialogGlobal } from './components/Modal';
import defaultMessages from './messages';

const registerComponents = (Vue, options) => {
    const { components } = options;

    if (components) {
        components.forEach((component) => {
            Vue.component(component.name, component);
        });
    }
};

const requireIcons = (icons) => {
    if (icons) {
        icons.forEach((name) => {
            require(`./assets/icons/${name}.svg`);
        });
    }
};

const requireIllustrations = (illustrations, useNewIllustrations) => {
    if (illustrations) {
        illustrations.forEach((name) => {
            if (useNewIllustrations) {
                require(`./assets/images/illustrations-new/${name}.svg`);
            } else {
                require(`./assets/images/illustrations/${name}.svg`);
            }
        });
    }
};

const createI18n = (Vue) => {
    const i18n = new Vue({
        data: {
            messages: defaultMessages,
        },

        methods: {
            setMessages(messages) {
                this.messages = messages;
            },
        },
    });

    return i18n;
};

const addPrototypes = (Vue, options = {}) => {
    Vue.prototype.$designSystem = {
        i18n: createI18n(Vue),
        onOverlayActive: options.onOverlayActive,
        onOverlayInactive: options.onOverlayInactive,
        useNewIllustrations: options.useNewIllustrations,
    };

    Vue.prototype.$toast = createToastGlobal(Vue, { useToastContainer: options.useToastContainer });

    Vue.prototype.$error = createErrorBannerGlobal(Vue, { ...options.errorBanner, useErrorBannerContainer: options.useErrorBannerContainer });

    Vue.prototype.$confirm = createConfirmDialogGlobal(Vue, { useConfirmModalContainer: options.useConfirmModalContainer });
};

const install = (Vue, options = {}) => {
    registerComponents(Vue, options);
    requireIcons(options.icons);
    requireIllustrations(options.illustrations, options.useNewIllustrations);
    addPrototypes(Vue, options);
};

export default {
    install,
};

// Reexport all public components
export * from './components';

// Reexport all public mixins
export * from './mixins';
